var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: { "has-error": _vm.error } },
    [
      _c("input", {
        staticClass: "form__input--checkbox checkbox-style--1",
        attrs: { id: _vm._uid, type: "checkbox", disabled: _vm.disabled },
        domProps: { checked: _vm.internalChecked },
        on: { input: _vm.handleInput },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "form__label", attrs: { for: _vm._uid } }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
        _vm.labelSuffix
          ? _c("small", [_vm._v(" (" + _vm._s(_vm.labelSuffix) + ")")])
          : _vm._e(),
        _vm._v(" "),
        _vm.showRequiredStar
          ? _c("span", { staticClass: "required" }, [_vm._v("*")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "form__error" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }